module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("运营总监")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)在公司经营战略指导下，制定网站总体定位，负责对公司整个电子商务平台的规划、搭建与营运；\n(2)根据目标市场，竞争态势，客户需求等调查，撰写市场分析、创意新的盈利模式，策划网站运营，业务拓展和产品销售的综合推广措施；\n(3)负责网站营销过程中与其他媒介的沟通，制定各种商务合作方案并监控实施，同时制定商务活动的推广计划、推广目标、实施评估与监控，确定宣传内容并采取多种方式和渠道宣传推广网站；负责网站品牌、诚信推广与建设，以及网络危机公关；\n(4)制定公司品牌管理策略，维护公司品牌；\n(5)根据公司经营方针和部门业务需要，合理设置部门组织结构和岗位，优化业务流程，提高部门工作效率，完成总经理下达的工作任务；\n(6)分析总结竞争对手，行业信息，公司产品信息等调研信息，确定调研结果，为公司的总体战略制定提供相关依据；\n(7)对日常运营工作及成员工作进行指导、监督；\n(8)项目信息系统框架的规划和设计，制定系统规划方案、可执行方案及预算；\n(9)领导安排的其他事宜；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)本科以上学历，电子商务、信息管理、工商管理、市场营销等相关专业；\n(2)5年以上电子商务运营工作经验，3年团队管理经验对网站运营工作有深刻认知，熟悉互联网、电子商务市场动态； \n(3)熟知网络营销和线下资源紧密结合五年以上企业管理经验；\n(4)有较强的执行力，能带领团队完成网站开发、规划、设计、到技术支持及运营管理整个流程； \n(5)具有敏锐的商业和市场意识，分析问题及解决问题能力强，具有优秀的资源整合能力和业务推进能力 \n(6)拥有良好的市场策划管理能力和团队协调工作能力，有组织实施的执行能力，有整合资源、创新经营的思想； \n(7)擅长撰写各类策划方案，具有优秀的文字组织能力、逻辑分析能力，富有激情与创意； \n(8)具有激励、沟通、协调、团队领导能力，责任心、事业心强，敢于承担责任；")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("运营经理")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)负责对网络销售渠道、运营体系的建立维护工作；\n(2)采集用户需求、调整产品、栏目发展规划及产品改进需求，提高产品栏目的访问量；\n(3)分析和挖掘市场需求，建立新的营销方式、优化营销工具，营销模式推广；\n(4)负责信息的搜集和分析工作，制定营销推广方案；\n(5)组织策划线上线下营销活动；\n(6)负责品牌产品规划设计工作；对公司网站的功能、布局提出改进方案；\n(7)建立运营数据分析模型，针对用户、用户行为、渠道等进行监控和统计，提供注册、充值、投注转化率，流失率等分析，给予运营指导性建议，增强用户黏性；\n(8)负责策略和活动的日常数据分析和评估，提高运营效率；\n(9)负责用户行为研究，监控不同分层用户的留存和活跃率；负责用户生命周期管理；\n(10)根据公司内外部资源，制定合适的网络推广策略；\n(11)负责相关营运数据的分析总结，执行相应的运行策略；\n(12)负责对运营助理工作的监督指导管理；\n(13)负责日常电子商务营运管理；\n(14)领导安排的其他事宜；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)本科以上学历水平，5年以上相关工作经验，3年团队管理经验；\n(2)对网站运营工作有深刻认知，熟悉互联网、电子商务市场动态；  \n(3)擅长撰写各类策划方案，具有优秀的文字组织能力、逻辑分析能力，富有激情与创意； \n(4)具备发展眼光，有很强的计划性和实施执行的能力； \n(5)具有激励、沟通、协调、团队领导能力，责任心、事业心强； \n(6)对数据分析有深刻的理解，了解数据分析的系统框架与理论模型，有产品、运营或产品运营经验者优先考虑； \n(7)从事过电子商务、新媒体运营管理者优先考虑； ")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("网络推广")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)能够根据公司发展要求，制定全面的搜索引擎优化策略，对SEO效果负责；\n(2)负责执行SEO，不断优化关键词、广告语、着陆页，找出最佳投放模式；\n(3)负责网站相关数据统计，对数据敏感，能合理分析数据并提出优化方向；\n(4)图文素材编写、及时更新和维护；\n(5)分析和总结竞争对手的SEO方法，并合理运用，不断提高网站的SEO效果；\n(6)协助完成项目的发展规划，促进网站知名度的提高；\n(7)加强与内部相关部门和组织外部的沟通与协作")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)大专以上学历，1年以上SEO工作经验，熟悉SEO操作流程并具备相关业务技能，SEO成功案例至少1个；\n(2)熟练操作常用的网页制作软件和网络搜索工具，了解网站开发、运行及维护的相关知识；  \n(3)熟悉搜索引擎优化的原理和策略，并有项目排到百度首页的成功案例经验； \n(4)精通外部链接，保证PR值,掌握搜索引擎优化、交换链接、群发等相关技术性推广，善于利用多种技术形式迅速提升网站的人气； \n(5)熟练掌握SEO技术（网站架构、网页代码、各大搜索引擎工作原理），有较广的推广渠道，有较好的论坛、博客、社区推广和经营的思维与策略； \n(6)较强的学习能力，团队合作意识强，擅于沟通； \n(7)有较强的文字功底，具备网站专题策划和信息采编能力；\n(8)有良好的职业素养、敬业精神及团队精神，擅于沟通； ")])])]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_c('p', [_vm._v("客服")])]), _vm._v(" "), _c('div', {
    staticClass: "statement"
  }, [_c('p', {
    staticClass: "request"
  }, [_vm._v("岗位职责：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)负责公司线上线下客户的维护工作，受理客户咨询、投诉、建议及意见等，并做好记录；\n(2)收集客户及相关市场资料，建立和管理客户档案和信息数据库；\n(3)维护良好的客户关系，进行有效的客户管理和沟通，掌握客户需求，不断提高客户满意度；\n(4)负责与相关部门的业务协调，及时解决客户提出的问题，促使成功交易；\n(5)负责线上渠道客户网络信息维护和更新；\n(6)负责客户订单处理、分配、和跟踪；\n(7)负责领导安排的其他相关事宜；")])]), _vm._v(" "), _c('div', {
    staticClass: "statement second"
  }, [_c('div', [_c('p', {
    staticClass: "request"
  }, [_vm._v("任职资格：")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("(1)中专以上学历，有淘宝、京东等电商客户服务经验者优先；\n(2)熟练使用办公软件，掌握网络和电话沟通方式，并能熟练运用；  \n(3)普通话标准，口齿清楚，声音甜美，优秀的语言表达能力和沟通能力； \n(4)较强的应变能力、协调能力，能独立处理紧急问题；\n(5)良好的服务意识、耐心和责任心，工作积极主动； \n(6)工作认真踏实、责任心强，具备团队精神；")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ee35852!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/join_us/HomeJoinOperate.vue
// module id = 158
// module chunks = 1